import { createSelector } from 'reselect';

export const themeSelector = (state) => state?.theme?.name || 'light';

export const darkThemeSelector = createSelector(
  themeSelector,
  (name) => name === 'dark',
);
